'use strict';
const angular = require('angular');

export class eformLinkComponent {
  /*@ngInject*/
  constructor($uibModal) {
    this.$uibModal = $uibModal;
  }

  openModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'eFormModal',
      resolve: {
        config: function(){
          return {
            eFormId: that.id
          }
        }
      }
    });

    modalInstance.result.then(
      function (eFormResponseId) { /* ok */ },
      function () { /* cancel */ }
    );
  }
}

export default angular.module('conduuApp.eformLink', [])
  .component('eformLink', {
    template: require('./eform-link.component.html'),
    bindings: {
      id: '@',
      icon: '@',
      text: '@',
      class: '@'
    },
    controller: eformLinkComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/eform-link/eform-link.component.js